import { HeadingTag } from "../../services/elements/dynamicTags";
import TooltipButton from "../buttons/tooltipButton/TooltipButton";
import { InfoParagraphProps } from "./infoParagraphProps";
import { Fragment } from "react";
import { HeadingEnum } from "../../enums/htmlTags";
import "./InfoParagraph.scss";

const InfoParagraph: React.FC<InfoParagraphProps> = (props) => {
  const { title, body } = props;
  const titleTooltip = title && title.titleTooltip ? title.titleTooltip : undefined;
  const bodyContext = body ? (body instanceof Array ? body : [body]) : undefined;

  return (
    <div className="info-paragraph-wrapper bg-white">
      {title ? (
        <div className="pt-3">
          <div className={"info-paragraph-wrapper_content"}>
            <HeadingTag type={title.titleType ?? HeadingEnum.h4} className={title.fontBold ? "fw-bold" : undefined}>
              {title.titleName}
            </HeadingTag>
          </div>
          {titleTooltip ? (
            <TooltipButton tooltipText={titleTooltip.tooltipText} modal={titleTooltip.modal} />
          ) : undefined}
        </div>
      ) : undefined}
      {!bodyContext
        ? undefined
        : bodyContext.map(({ bodyText, bodyTooltip }, index) => {
            if (!bodyText) {
              return undefined;
            }
            const isBodyElementType = typeof bodyText !== "string";
            return (
              <Fragment key={index}>
                <div className="info-paragraph-wrapper_content">
                  {!isBodyElementType ? <p>{bodyText}</p> : <>{bodyText}</>}
                </div>
                {bodyTooltip ? (
                  <TooltipButton tooltipText={bodyTooltip.tooltipText} modal={bodyTooltip.modal} />
                ) : undefined}
              </Fragment>
            );
          })}
    </div>
  );
};

export default InfoParagraph;
